export const ERROR_CODE = {
  SUCCESS: '0',
  TOKEN_INVALID: '10001'
};

export const ERROR_MESSAGE = {
  [ERROR_CODE.SUCCESS]: '成功',
  [ERROR_CODE.TOKEN_INVALID]: '登录信息失效，请重新登录'
};

// @see https://docs.corp.kuaishou.com/d/home/fcADmQjQDFlUaWkaEK22KDhVd
// 有些错误码不能提示网络异常，需要把服务端错误信息透出给用户
// 如果需要前端重写该错误信息，直接覆盖错误码对应的值
export const ERROR_MESSAGE_SHOW_WHITE_LIST: Record<number, string> = {
  10001: '', // 已存在预开方单，无法再次创建
  10002: '', // 处方单中存在重复的药品，请修改后提交
  10003: '', // 处方单中存在重复的诊断，请修改后提交
  10004: '', // 14岁以下的患者体重为必填
  10005: '', // 已存在电子处方，无法更新
  10010: '', // 已存在电子处方，无法发送
  10011: '', // 预开方单异常，请退出页面重新进入
  10012: '', // 存在开方风险，请根据问诊小助手诊断提示修改处方
  10021: '',
  10022: '',
  10031: '',
  10041: '',
  10042: '',
  10043: '',
  10044: '',
  10045: '',
  10046: '',
  10051: '',
  10061: '',
  10062: '',
  10081: '', // 无在线医师
  10091: '', // 咨询订单已结束
  10071: '', // 保存地址失败
  10072: '', // 最多添加20个收货地址
  8001: '', // 医生入驻，请选择需要开通的服务
  8002: '', // 医生入驻，服务价格上限
  109: '',
  10101: '',
  10102: '',
  13004: '', // 请勿设置联系方式
};
